import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";
import app from "./app";
import ui from "./ui";
import user from "./user";
import tabs from "./tabs";
import content from "./content";
import customer from "./customer";
import headerSearch from "./headerSearch";
import liveSearch from "./liveSearch";
import filter from "./filter";
import client from "./client";
import knowledgeBase from "./knowledgeBase";
import appeal from "modules/appeal/reducer";
import calendar from "modules/calendar/reducer";
import emails from "./emails";
import changeHistory from "./changeHistory";
import call from "./call";
import audioplayer from "./audioplayer";
import knowledges from "./knowledges";
import session from "./session";
import settings from "./settings";
import searchFilter from "./searchFilter";
import search from "./search";
import dashboard from "./dashboard";
import dynamicDashboard from "./dynamicDashboard";
import order from "./order";
import grid from "./grid";
import notificationHistory from "./notificationHistory";
import staticBlocks from "./staticBlocks";
import exportWizard from "./exportWizard";
import componator from "./componator";
import attributesFilters from "./attributesFilters";
import layoutCollapse from "./layoutCollapse";
import sidebarFilters from "./sidebarFilters";
import spec from "./spec";

const appReducer = combineReducers({
    routing: routerReducer,
    ui,
    app,
    user,
    tabs,
    content,
    form: formReducer,
    customer,
    headerSearch,
    liveSearch,
    filter,
    client,
    knowledgeBase,
    appeal,
    changeHistory,
    emails,
    call,
    audioplayer,
    knowledges,
    session,
    settings,
    searchFilter,
    search,
    dashboard,
    dynamicDashboard,
    order,
    grid,
    calendar,
    notificationHistory,
    staticBlocks,
    exportWizard,
    componator,
    attributesFilters,
    layoutCollapse,
    sidebarFilters,
    spec,
});

const rootReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_STATE":
            return {
                ...state,
                tabs: {
                    ...state.tabs,
                    tabCachingEnabled: true,
                },
                ...action.nextState,
            };

        default:
            return appReducer(state, action);
    }
};

export default rootReducer;
